const terminalDetect_CN = {
  terminalDetect_dashboard: '工作台',
  terminalDetect_equipment_management: '设备管理',
  terminalDetect_title: '终端检测',
  terminalDetect_detection_tab: '检测列表',
  terminalDetect_qualified_tab: '合格列表',
  terminalDetect_search: '搜索',
  terminalDetect_imei: 'IMEI',
  terminalDetect_please_input: '请输入',
  terminalDetect_state: '状态',
  terminalDetect_all: '全部',
  terminalDetect_normal: '正常',
  terminalDetect_abnormal: '异常',
  terminalDetect_isonline: '是否在线',
  terminalDetect_yes: '是',
  terminalDetect_no: '否',
  terminalDetect_empty: '清空',
  terminalDetect_isonlocation: '是否定位',
};

export default terminalDetect_CN;